<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">短信管理</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>短信类型：</label>
          <el-select v-model="type" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
<!--        <div class="content-input-item">-->
<!--          <label>使用状态：</label>-->
<!--          <el-select v-model="state" placeholder="Select" style="width: 6.4em">-->
<!--            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </div>-->
<!--        <div class="content-input-item">-->
<!--          <label>平台：</label>-->
<!--          <el-select v-model="platformType" placeholder="Select" style="width: 6.4em">-->
<!--            <el-option v-for="item in platformTypeArray" :key="item.value" :label="item.label" :value="item.value">-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </div>-->
        <div class="content-input-item">
          <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType" :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-input type="search" v-model="inputPhone" placeholder="请输入手机号" :maxlength="11" style="margin-right: 8px; width: 24em">
            <template #prepend>
              <el-select v-model="inputType" placeholder="Select" style="width: 8em">
                <el-option v-for="item in inputTypeArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-input>
          <el-button type="primary" @click="submitPhone()" v-loading="inputLoading">发送短信</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            border
            @cell-click="toggleSelection"
            v-loading="listLoading"
        >
          <!--          <el-table-column type="selection" width="55" />-->
<!--          <el-table-column property="createTime" label="生成时间" v-if="checkColList.indexOf('生成时间') > -1"/>-->
          <el-table-column property="phone" label="手机号" v-if="checkColList.indexOf('手机号') > -1" />
          <el-table-column property="code" label="校验码" v-if="checkColList.indexOf('校验码') > -1"/>
          <el-table-column property="" label="类型" v-if="checkColList.indexOf('类型') > -1" >
            <template #default="scope">
              <span>{{scope.row.type==1?'手机号注册':scope.row.type==2?'忘记密码':scope.row.type==3?'创业者修改提现密码':scope.row.type==4?'第三方注册':''}}</span>
            </template>
          </el-table-column>
          <el-table-column property="endTime" label="有效时间" v-if="checkColList.indexOf('有效时间') > -1" />
          <el-table-column property="" label="平台" v-if="checkColList.indexOf('平台') > -1">
            <template #default="scope">
              <p>{{ scope.row.platformType == 1?'Android':scope.row.platformType == 2?'IOS':scope.row.platformType == 3?'web':''}}</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="使用状态" v-if="checkColList.indexOf('使用状态') > -1">
            <template #default="scope">
              <p>{{ scope.row.state == 0?'未使用':scope.row.state == 1?'已使用':''}}</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
              {{ scope.row.isSend == 0?'发送失败':scope.row.isSend == 1?'发送成功':''}}
            </template>
          </el-table-column>
          <el-table-column property="extraCode" label="防刷码" v-if="checkColList.indexOf('防刷码') > -1"> </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import BtnGroup from '../../components/BtnGroup'
import { getSmsVerifyPageList, addSmsVerify } from '../../api/url'
import {getFormData, postFormData} from '../../api/api'
import Dialog from '../../assets/js/dialog'
import UserLogDialog from '../../components/UserLog/UserLogDialog'
import ImgViewer from '../../assets/js/imageViewer'
import { common } from "@/assets/shared/select-constant";
import UserLog from "@/components/UserLog/UserLog";
// import InviteDetailDialog from "./components/InviteDetailDialog"
import { phoneReg } from "@/assets/shared/reg-constant";

export default {
  name: "SmsVerify",
  components: { SearchComponents, BtnGroup },
  data() {
    return {

      typeArray: [
        { label: '不限', value: -1},
        { label: '手机号注册', value: 1},
        { label: '第三方注册', value: 4},
        { label: '忘记密码', value: 2},
        { label: '创业者修改提现密码', value: 3},
      ],
      type: -1,

      // stateArray: [
      //   { label: '不限', value: -1},
      //   { label: '未使用', value: 0},
      //   { label: '已使用', value: 1},
      // ],
      // state: -1,
      //
      // platformTypeArray: [
      //   { label: '不限', value: -1},
      //   { label: 'Android', value: 1},
      //   { label: 'IOS', value: 2},
      // ],
      // platformType: -1,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
      ],
      searchType: 1,
      searchValue: '',

      //刷新组
      colList: [ '手机号', '校验码', '类型', '有效时间', '平台', '使用状态', '状态', '防刷码'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

      inputTypeArray: [
        { label: '手机号注册', value: 1},
        { label: '第三方注册', value: 4},
        { label: '忘记密码', value: 2},
        { label: '创业者修改提现密码', value: 3},
      ],
      inputType: 1,

      inputPhone: '',
      inputLoading: false,

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      // this.isChecked = true;
      this.type = -1;
      // this.state = -1;
      // this.platformType = -1;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['type'] = this.type;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      // param['state'] = this.state;
      // param['platformType'] = this.platformType;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getSmsVerifyPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(row) {
      let imgList = []
      imgList.push(row.headImg.headImg)
      ImgViewer.open({
        imgList: imgList
      })
    },

    toggleSelection(row, column, cell, event) {

      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

    },

    submitPhone() {
      if (!this.inputPhone) {
        this.$message({
          message: '请输入手机号',
          duration: 2000,
          type: 'warning'
        })
        return false
      } else if (!phoneReg.test(this.inputPhone)) {
        this.$message({
          message: '手机号错误',
          duration: 2000,
          type: 'warning'
        })
        return false
      }
      this.$confirm('确认发送短信？').then(()=>{
        this.inputLoading = true
        let param = {}
        param['type'] = this.inputType
        param['phone'] = this.inputPhone
        postFormData(addSmsVerify, param).then((data)=>{
          let {msg, code } = data;
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.refreshParam()
          }else{
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.inputLoading = false;
        }).catch(()=>{
          this.inputLoading = false;
        })
      })
    }


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
